<template>
  <div>
    <PageAllow controller="Qacenter" action="view" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color pa-4">
      <v-card class="page-card">
        <v-expansion-panels v-model="panels" multiple accordion>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-card-title class="ms-n4 py-0">
                {{ qacenter_question.title }}
                <v-spacer />
              </v-card-title>
            </v-expansion-panel-header>

            <v-divider></v-divider>

            <v-expansion-panel-content>
              <v-row
                v-for="(item, i) in QacenterAnswers"
                :key="i"
                class="ma-0"
                :style="{
                  'justify-content':
                    item.user_flag == 1 ? 'flex-start' : 'flex-end',
                }"
              >
                <!-- left -->
                <v-card-subtitle>
                  <p v-if="item.user_flag == 1">
                    {{ item.user_info }} {{ item.created | formatTime }}
                    <br />
                    <v-card class="pa-4 grey lighten-3 overflow-hidden">
                      <span v-if="qacenter_question.return_order_id">
                        <a
                          @click="
                            $router.push(
                              '/return-orders/' +
                                qacenter_question.return_order.id
                            )
                          "
                        >
                          {{ qacenter_question.return_order.order_code }}
                        </a>
                      </span>
                      <!-- 新品反馈 -->
                      <span v-if="qacenter_question.type == 1">
                        <span>
                          {{ $t("QuestionDetail.feedback.title")
                          }}{{ qacenter_question.title }}
                        </span>
                        <br />
                        <span>
                          {{ $t("QuestionDetail.feedback.text")
                          }}{{ qacenter_question.text }}
                        </span>
                        <br />
                        <span>
                          {{ $t("QuestionDetail.feedback.advice_text")
                          }}{{ qacenter_question.advice_text }}
                        </span>
                      </span>
                      <span v-else>
                        {{ item.text }}
                      </span>
                      <div class="overflow-hidden">
                        <div
                          v-for="(file, i) in item.album"
                          :key="i"
                          class="float-left mr-2"
                        >
                          <v-img
                            max-width="240"
                            :src="file"
                            @click.stop="$showFullscreenImages([file])"
                            v-if="
                              ['jpg', 'jpeg', 'gif', 'png'].includes(
                                file
                                  .substring(file.lastIndexOf('.') + 1)
                                  .toLowerCase()
                              )
                            "
                          />
                          <video width="240" controls v-else>
                            <source :src="file" type="video/mp4" />
                          </video>
                        </div>
                      </div>
                    </v-card>
                  </p>
                  <!-- right -->
                  <p v-else class="text-right">
                    {{ item.created | formatTime }} {{ item.user_info }}
                    <br />
                    <v-card class="grey lighten-3 text-left pa-4">
                      {{ item.text }}
                      <v-img
                        max-width="240"
                        :src="item.img_path[0]"
                        @click.stop="$showFullscreenImages([item.img_path[0]])"
                      />
                    </v-card>
                  </p>
                </v-card-subtitle>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- 提交 -->
        <v-expansion-panels
          class="mt-4"
          v-model="panelsDetail"
          multiple
          accordion
        >
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-card-title class="ms-n4 py-0">
                {{ $t("QuestionDetail.title") }}
              </v-card-title>
            </v-expansion-panel-header>

            <v-divider></v-divider>

            <v-expansion-panel-content>
              <ValidationObserver ref="observer">
                <v-col>
                  <v-card flat>
                    <v-card-text>
                      <!-- 投诉归类 -->
                      <v-row align="center" class="my-1">
                        <v-col cols="2" class="font-weight-bold text-left">
                          {{
                            $t("QuestionDetail.qacenter_category") +
                            $t("Global.colon")
                          }}
                          <br />
                        </v-col>
                        <v-col cols="8">
                          <!-- :value="this.qacenter_category" -->
                          <SearcherQacenterCategory
                            v-model="qacenter_category"
                            @input="categotyInput($event, qacenter_question.id)"
                            label="请选择"
                            :categrayRefresh="categrayRefresh"
                          />
                        </v-col>
                        <v-col cols="2">
                          <v-btn
                            v-if="
                              $permission.permissionAllow(
                                'QacenterCategories',
                                'add'
                              )
                            "
                            small
                            color="primary"
                            @click.stop="
                              currentItem = { id: 0 };
                              editDialog = true;
                            "
                            class="ms-1"
                          >
                            <v-icon x-small class="pe-1">fa-plus</v-icon>
                            {{
                                $t("QacenterCategory.ObjectName"),
                            }}
                          </v-btn></v-col
                        >
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col>
                  <v-card flat>
                    <v-card-text>
                      <v-row align="center" class="my-1">
                        <v-col cols="2" class="font-weight-bold text-left">
                          {{
                            $t("QuestionDetail.standard_reply") +
                            $t("Global.colon")
                          }}
                          <br />
                        </v-col>
                        <v-col cols="8">
                          <SearcherStandardRequest
                            @input="input($event)"
                            :refresh="refresh"
                          />
                        </v-col>
                        <v-col cols="2">
                          <v-btn
                            small
                            color="primary"
                            class="ms-1"
                            @click.stop="Add = true"
                          >
                            <v-icon x-small class="pe-1">fa-plus</v-icon>
                            {{ $t("QacenterStandardRequests.add") }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col>
                  <!-- <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('QuestionDetail.text')"
                  rules="required"
                > -->
                  <span class="d-flex">
                    <v-textarea
                      v-model="text"
                      :hint="$t('QuestionDetail.text')"
                      outlined
                      auto-grow
                    />
                  </span>
                  <!-- </ValidationProvider> -->
                </v-col>
                <v-col>
                  <v-card flat>
                    <!-- <v-img :src="img" @click.stop="imgClick()">
                    <v-tooltip right>
                      <span> {{ $t("QuestionDetail.delImg") }}</span>
                    </v-tooltip>
                  </v-img> -->
                    <v-card-text>
                      <v-row align="center" class="my-1">
                        <v-col cols="2" class="font-weight-bold text-left">
                          {{
                            $t("QuestionDetail.up_image") + $t("Global.colon")
                          }}
                          <br />
                          <!-- <v-btn
                          color="primary"
                          class="my-1"
                          x-small
                          outlined
                          @click.stop="clearImage('app_loading_page')"
                        >
                          {{ $t("BusinessSetting.AppAndWxApp.clear_image") }}
                        </v-btn> -->
                        </v-col>
                        <v-col cols="8">
                          <v-card v-if="img" max-width="140px">
                            <v-img
                              :src="img"
                              @click.stop="$showFullscreenImages([img])"
                            >
                              <v-tooltip right v-if="img">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    color="secondary"
                                    class="pa-2 float-right"
                                    @click.stop="img = null"
                                  >
                                    fa-times
                                  </v-icon>
                                </template>
                                <span>
                                  {{ $t("QuestionDetail.clear_image") }}</span
                                >
                              </v-tooltip>
                            </v-img>
                          </v-card>
                          <v-file-input
                            ref="img_file"
                            show-size
                            prepend-icon="fa-camera"
                            accept="image/png, image/jpeg"
                            persistent-hint
                            :placeholder="$t('QuestionDetail.imgPlaceholder')"
                            :hint="
                              $t('QuestionDetail.imgHint', ['1080', '1920'])
                            "
                            :rules="imgRules"
                            v-model="img_file"
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                  <!-- <v-file-input
                  id="file"
                  ref="img_file"
                  show-size
                  accept="image/png, image/jpeg"
                  persistent-hint
                  v-model="img_file"
                  hide-input
                  style="display: none"
                >
                </v-file-input> -->
                  <!-- <v-btn
                  style="margin-top: 15px"
                  @click.stop="imgClick()"
                  color="info"
                >
                  上传图片
                </v-btn> -->
                </v-col>
              </ValidationObserver>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn
                outlined
                color="secondary"
                class="elevation-1"
                block
                @click="$router.push('/qacenter')"
              >
                <v-icon small class="pe-1">fa-times</v-icon>
                {{ $t("CRUD.backToList", [$t("Nav.complaint")]) }}
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn
                dark
                color="action"
                class="elevation-1"
                @click.stop="Submit()"
                block
              >
                {{ $t("QuestionDetail.submit") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
    <!-- 新增标准回复 -->
    <v-dialog v-model="Add" width="600px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("QacenterStandardRequests.detail") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="Add = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 subtitle-1">
          <ValidationObserver ref="requestObserver">
            <v-row>
              <v-col cols="2" class="font-weight-bold text-right">
                {{ $t("QacenterStandardRequests.code")
                }}{{ $t("Global.colon") }}
                <span class="red--text">*</span>
              </v-col>
              <v-col cols="10">
                <ValidationProvider rules="required">
                  <v-text-field
                    v-model="addCode"
                    single-line
                    dense
                    hide-details
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="2" class="font-weight-bold text-right">
                {{ $t("QacenterStandardRequests.title")
                }}{{ $t("Global.colon") }}
                <span class="red--text">*</span>
              </v-col>
              <v-col cols="10">
                <ValidationProvider rules="required">
                  <v-text-field
                    v-model="addTitle"
                    single-line
                    dense
                    hide-details
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="2" class="font-weight-bold text-right">
                {{
                  $t("QacenterStandardRequests.context") + $t("Global.colon")
                }}
                <span class="red--text">*</span>
              </v-col>
              <v-col cols="10">
                <ValidationProvider rules="required">
                  <v-textarea v-model="addContext" outlined auto-grow />
                </ValidationProvider>
              </v-col>
            </v-row>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="Add = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="primary" depressed @click="AddConfirm()">
            {{ $t("$vuetify.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 新增一级分类 -->
    <v-dialog persistent v-model="editDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ $t("QacenterCategory.ObjectNameInfo") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="editDialog = false"
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("Nav.question_category")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="categoryObserver">
              <v-form>
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('QacenterCategory.Fields.category_number')"
                      rules="required"
                    >
                      <v-text-field
                        required
                        v-model="currentItem.number"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(categoryServerErrors, 'number')
                            .concat(errors)
                        "
                      >
                        <template v-slot:label>
                          {{ $t("QacenterCategory.Fields.category_number") }}
                          <span class="red--text">*</span>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('QacenterCategory.Fields.category_name')"
                      rules="required"
                    >
                      <v-text-field
                        required
                        v-model="currentItem.name"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(categoryServerErrors, 'name')
                            .concat(errors)
                        "
                      >
                        <template v-slot:label>
                          {{ $t("QacenterCategory.Fields.category_name") }}
                          <span class="red--text">*</span>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="editDialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
          <v-btn color="accent" @click="save()">{{ $t("CRUD.save") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import Qacenter from "@/api/qacenter.js";
import Reauest from "@/api/standard_requests.js";
import SearcherQacenterCategory from "@/components/plugins/SearcherQacenterCategory";
import SearcherStandardRequest from "@/components/plugins/SearcherStandardRequest";
import Files from "@/api/files";
// import { ValidationObserver } from "vee-validate";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import QacenterCategories from "@/api/qacenter_category";

export default {
  data: () => ({
    panels: [0],
    panelsDetail: [0],
    qacenter_question: {},
    qacenter_category: null,
    qacenter_answers: [],
    text: "",
    img_file: null,
    img: "",
    serverErrors: [],
    categoryServerErrors: [],
    imgRules: [
      (value) =>
        !value ||
        value.size < 5000000 ||
        i18n.t("QuestionDetail.questionImgHint"),
    ],
    Add: false,
    addCode: "",
    addTitle: "",
    addContext: "",
    refresh: false,
    categrayRefresh: false,
    currentItem: {},
    editDialog: false,
  }),
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherQacenterCategory,
    SearcherStandardRequest,
    ValidationObserver,
    ValidationProvider,
  },
  computed: {
    QacenterCategory() {
      return this.qacenter_category;
    },

    QacenterAnswers() {
      return this.qacenter_answers;
    },
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.customerMaintenance"),
        disabled: false,
        href: "/qacenter",
      },
      {
        text: i18n.t("Nav.complaint"),
        disabled: false,
        href: "/qacenter",
      },
      {
        text: i18n.t("Nav.question_detail"),
        disabled: true,
      },
    ],
  },

  mounted() {
    this.getQacenterDetailFromAPI();
  },

  methods: {
    input(e) {
      if (e !== null) {
        this.text = e.context;
      } else {
        this.text = "";
      }
    },
    categotyInput(e, id) {
      if (id) {
        if (e) {
          var data = [];
          data.push({
            category_id: e.id,
          });
          Qacenter.edit(id, data[0]).then(
            function (response) {
              if (response.data.status.isOK()) {
                // this.$snackbar.success(i18n.t("Complaint.category_text"));
              }
            }.bind(this)
          );
        }
      }
    },

    imgClick() {
      document.querySelector("#file").click();
    },
    getQacenterDetailFromAPI() {
      Qacenter.fetchOne(this.$route.params.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.qacenter_question = response.data.qacenter_question;
            this.qacenter_answers =
              response.data.qacenter_question.qacenter_answers.map((item) => {
                item.album = [];
                if (item.file_url.image_url) {
                  item.file_url.image_url.forEach((img) => {
                    item.album.push(img);
                  });
                }
                if (item.file_url.video_url) {
                  item.file_url.video_url.forEach((video) => {
                    item.album.push(video);
                  });
                }
                return item;
              });

            this.qacenter_category = this.qacenter_question.qacenter_category;
          }
        }.bind(this)
      );
    },

    Submit() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            if (!this.img_file && !this.text) {
              this.$store.dispatch("fullscreenLoadingStop");
              this.$snackbar.error(
                i18n.t("QuestionDetail.Messages.contentNull")
              );
            } else {
              if (this.img_file) {
                let response = await Files.imageQacenterUpload(
                  this.img_file,
                  true
                );
                if (response.data.status.isOK()) {
                  this.qacenter_question.img_path = response.data.data.img_url;
                  this.qacenter_question.img_name = response.data.data.img_name;
                  this.qacenter_question.thumbnail =
                    response.data.data.thumbnail;
                }
              }
              var data = [];
              data.push({
                question_id: this.$route.params.id,
                text: this.text,
                category_id: this.category_id,
                img_path: [
                  this.qacenter_question && this.qacenter_question.img_name
                    ? this.qacenter_question.img_name
                    : "",
                ],
              });

              // 最终提交
              Qacenter.submit(data[0])
                .then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.getQacenterDetailFromAPI();
                    }
                    this.$store.dispatch("fullscreenLoadingStop");
                    this.$router.replace("/qacenter");
                  }.bind(this)
                )
                .catch(
                  function () {
                    this.$store.dispatch("fullscreenLoadingStop");
                  }.bind(this)
                );
            }
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    AddConfirm() {
      var data = [];
      data.push({
        code: this.addCode,
        title: this.addTitle,
        context: this.addContext,
      });
      this.$refs.requestObserver.validate().then(
        function (result) {
          if (result) {
            Reauest.add(data[0]).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.refresh = !this.refresh; //触发标准回复列表刷新
                  this.Add = false;
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
    save() {
      this.$store.dispatch("fullscreenLoading");
      this.categoryServerErrors = [];
      this.$refs.categoryObserver.validate().then(
        function (result) {
          if (result) {
            QacenterCategories.save(this.currentItem.id, this.currentItem)
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.editDialog = false;
                    this.$store.dispatch("fullscreenLoadingStop");
                    this.categrayRefresh = !this.categrayRefresh; //触发投诉归类列表刷新
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.categoryServerErrors = response.data.error.data;
                    this.$store.dispatch("fullscreenLoadingStop");
                  }
                }.bind(this)
              )
              .catch(
                function () {
                  this.editDialog = false;
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
  },
  watch: {
    img_file: {
      handler() {
        if (this.img_file) {
          var reader = new FileReader();
          reader.readAsDataURL(this.img_file);
          let that = this;
          reader.onload = function () {
            that.img = this.result;
          };
        } else {
          this.img = "";
        }
      },
    },
    Add: {
      handler() {
        if (!this.Add) {
          this.addCode = "";
          this.addTitle = "";
          this.addContext = "";
        }
      },
    },
    editDialog: {
      handler() {
        if (!this.editDialog) {
          this.$refs.categoryObserver.reset();
          this.categoryServerErrors = [];
          this.$store.dispatch("fullscreenLoadingStop");
        }
      },
    },
  },
};
</script>

<style>
</style>